import axios from "infra/http";
import { TimelineLog} from "components/TimelineLogs";
import { useQuery } from "react-query"; 

function useHistoricoEncomenda(id: string | undefined) {
  return useQuery(
    `/v1/encomenda/${id}/historico`,
    async () => {
      const { data } = await axios.get< TimelineLog[]>(
        `/v1/encomenda/${id}/historico`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useHistoricoEncomenda;
